export default function () {
	return {
		itemsToShow: 10,
		initialWordsCount: 10, // The number of rows to show initially
		secondWordCount: 35,
		loadingMoreWords: false,
		// numberOfButtonClick: 1,
		tableRef: null,
		// sortingDropdownIsOpen: false,
		tableWordsExtended: [],
		definitionStates: {}, // { [index]: true|false }
	};
}
